import { Button } from "@mui/material";
import { ActionsMenu } from "@zfp-akademie-a-s/zfp-design";
import { HandshakeIcon } from "Components/_Shared/Icons/Icons";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import type React from "react";
import { useState } from "react";

const ATLANTIK_URL = "https://app.atlantik.cz/";

export const GoalsFulfillmentContractingPartners = () => {
  const { t } = useResource();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        variant="text"
        color="primary"
        onClick={handleClick}
        aria-controls={open ? "contracting-partners-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        startIcon={<HandshakeIcon />}
        sx={{ textTransform: "none" }}
      >
        {t(Resources.AnalysisDetail.GoalsFulfillment.ContractingPartnersMenu.Title)}
      </Button>

      <ActionsMenu
        id="contracting-partners-menu"
        anchorEl={anchorEl}
        onClose={handleClose}
        items={[
          {
            label: t(Resources.AnalysisDetail.GoalsFulfillment.ContractingPartnersMenu.Atlantik),
            onClick: () => window.open(ATLANTIK_URL, "_blank", "noopener,noreferrer"),
          },
        ]}
      />
    </div>
  );
};
